// extracted by mini-css-extract-plugin
export var label = "_fr-2";
export var slideContainer = "_fr-0";
export var slider = "_fr-1";